import "./PersonalInfoConfirmationModal.scss";
import { Form, message, Modal } from "antd";
import { useSelector } from "react-redux";
import MondayButton from "../../../commonComponents/MondayButton/MondayButton";
import InfoText from "../../../commonComponents/InfoText/InfoText";
import MultipleInputs from "./MultipleInputs";
import { useAuth } from "../../../../authentication/authHelpers";
import { useMemo, useState } from "react";
import RenderDynamicComponents from "../../../RenderDynamicComponents/RenderDynamicComponents";
import fieldsJSON from "./fieldsJSON";
import dayjsTZ from "../../../../utils/dayjs";
import { API } from "../../../../helpers/API/amplifyApi";
import { notificationUserToAdmin } from "../../../../utils/sendNotification";
import {
  emergencyContactDynamicFields,
  emergencyContactRequiredRule,
  normalizeEmergencyContacts,
} from "../../../punonjesit/EmployeeView/Personal/emergencyContactConfig";

const PersonalInfoConfirmationModal = ({ open, setOpen }) => {
  const [form] = Form.useForm();
  const { employee, user } = useAuth();

  const { isDarkMode } = useSelector((state) => state.usersList);

  const [loading, setLoading] = useState(false);

  const handleConfirm = () => {
    if (!employee?.employeeId) {
      message.error("Dicka shkoi gabim! Kontaktoni supervizorin tuaj.");
      setOpen(false);
      return;
    }
    setLoading(true);
    form
      .validateFields()
      .then(async (values) => {
        const employeeEmergencyContact = normalizeEmergencyContacts(
          values?.employeeEmergencyContact
        ).filter(
          (row) =>
            row?.fullName?.trim() &&
            row?.email?.trim() &&
            row?.phoneNumber?.toString()?.trim() &&
            row?.relationship?.trim()
        );

        const {
          employeeEmergencyContact: _ignored,
          employeeDayOfBirth,
          ...restValues
        } = values;

        await API.put("employees", `/employees/${employee?.employeeId}`, {
          body: {
            ...restValues,
            ...(employeeDayOfBirth
              ? {
                  employeeDayOfBirth: dayjsTZ(employeeDayOfBirth).valueOf(),
                }
              : {}),
            employeeEmergencyContact,
            dataVerification: {
              isVerified: true,
              verifiedAt: dayjsTZ().valueOf(),
              verifiedBy: employee?.employeeEmailWork,
              verifiedFields: values,
            },
            keylog: [
              ...(employee?.keylog || []),
              {
                activity: "Ndryshuar",
                author: user?.given_name + " " + user?.family_name,
                changeDate: dayjsTZ().valueOf(),
                oldValue: "",
                newValue: "Konfirmoi të dhënat personale",
              },
            ],
          },
        })
          .then((res) => {
            const notifBody = {
              notificationTitle: "Konfirmim i të dhënave personale",
              notificationBody: `Punonjësi ${
                employee?.employeeFirstName + " " + employee?.employeeLastName
              } konfirmoi të dhënat e tij/saj personale.`,
              notificationUrl: `/punonjesit/specifikat/${employee?.employeeId}`,
              createdAt: dayjsTZ().format("DD/MM/YYYY"),
              notificationPriority: false,
              notificationCategory: "Info",
              isAnnouncement: false,
              notificationFirstName: user?.given_name,
              notificationLastName: user?.family_name,
            };
            notificationUserToAdmin(notifBody, user?.allUsers?.Items || []);
            setOpen(false);
            form.resetFields();
            message.success("Faleminderit për kohën tuaj!");
          })
          .catch((err) => console.log("err: ", err))
          .finally(() => setLoading(false));
      })
      .catch((error) => {
        setLoading(false);
        message.error("Ju lutem plotësoni të gjitha fushat e detyrueshme!");
      });
  };

  const currentValue = useMemo(() => {
    if (!employee) return null;

    const currentValue = normalizeEmergencyContacts(
      employee?.employeeEmergencyContact
    );
    for (const field of fieldsJSON) {
      const val = employee[field.formItemName];
      if (!val) continue;
      const toSet =
        field?.type === "datepicker" || field?.type === "timepicker"
          ? dayjsTZ(val)
          : val;
      form.setFieldValue(field.formItemName, toSet);
    }
    form.setFieldValue("employeeEmergencyContact", currentValue);

    return currentValue;
  }, [employee, form]);

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      centered
      className={`personalInfoConfirmationModal ${
        isDarkMode ? "dark darkHeader" : "lightHeader"
      }`}
      footer={[
        <MondayButton
          className="mondayButtonGreen"
          onClick={handleConfirm}
          spin={loading}
        >
          Konfirmo
        </MondayButton>,
      ]}
      title={"Konfirmo të dhënat e tua personale"}
      destroyOnHidden={true}
      closeIcon={false}
    >
      <InfoText
        text={
          "Këto janë të dhënat e tua personale të ruajtura në portal. Ju lutem konfirmoni këto të dhëna dhe të tjera që mund të mungojnë. Kujtesë që këto të dhëna janë të mbrojtura dhe do të përdoren vetëm për qëllime të brendshme."
        }
      />
      <Form form={form}>
        <div className="confirmationModalContent">
          <div className="personalInfo">
            {RenderDynamicComponents(fieldsJSON, form)}
          </div>

          <MultipleInputs
            form={form}
            name="employeeEmergencyContact"
            value={currentValue}
            label="Kontakt emergjence"
            dynamicFields={emergencyContactDynamicFields}
            rules={[emergencyContactRequiredRule]}
          />
        </div>
      </Form>
    </Modal>
  );
};

export default PersonalInfoConfirmationModal;
